export const AppContextActionTypes = {
  setAppContext: "SET_APP_CONTEXT"
}